import { combineReducers } from 'redux';

import chatResources from './chatResources/reducer';

export default combineReducers({
  chatResources
});



/** WEBPACK FOOTER **
 ** ./src/members/state/chat/paging/reducer.js
 **/